export { BvlLinkComponent as BvlLink } from './link.component';
export { BvlLinkModule } from './link.module';
